
import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { Box, CssBaseline, Typography, Grid } from '@mui/material';
import { data } from "./csvjson";
import PricingTableHeader from './PricingTableHeader';
import PricingTableRow from './PricingTableRow';
import PricingTablePagination from './PricingTablePagination';
import FilterControls from './FilterControls';
import { styled } from '@mui/system';
import { Button,IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import {downloadButtonStyle} from "./styles";
import Papa from 'papaparse';
import { Analytics } from '@vercel/analytics/react';




const StyledPaper = styled(Paper)({
  borderRadius: '15px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
  border: '1px solid #f0f0f0',
  padding: '2rem'
});


export default function PricingTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState('');
  const uniqueRegionNames = new Set(data.map((row) => row.region_name));
  const [filteredData, setFilteredData] = useState(data);
  const [regionFilter, setRegionFilter] = useState('East US');
  const [termFilter, setTermFilter] = useState('3 Years')
  function handleDownload() {
    const csv = Papa.unparse(filteredData);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'filtered_data.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  useEffect(() => {
    const filtered = data.filter((row) => row.region_name === regionFilter)
        .filter((row) => row.region_name === regionFilter)
        .filter((row) => row.name.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => {
      return (a.vCPUs - b.vCPUs) !== 0 ? (a.vCPUs - b.vCPUs) : (a.MemoryGB - b.MemoryGB)
    });
    setFilteredData(filtered);
    setPage(0);
  }, [regionFilter, searchQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData
    .filter((row) => row.region_name === regionFilter)
    .filter((row) => row.name.toLowerCase().includes(searchQuery.toLowerCase()))
    .slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

  return (
    <React.Fragment>
      <Analytics />
      <CssBaseline />
      <Grid container direction="column" spacing={2} style={{ padding: '20px 40px' }}>
        <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ padding: '20px 40px' }}>
          <Grid item xs={12} sm={9}>
            <FilterControls
              uniqueRegionNames={uniqueRegionNames}
              regionFilter={regionFilter}
              setRegionFilter={setRegionFilter}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              termFilter={termFilter}
              setTermFilter={setTermFilter}
            />
          </Grid>
          <Grid item xs={12} sm={3} style={{ textAlign: 'right' }}>
            <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
                sx={downloadButtonStyle}
                    >
              Pricing Data
            </Button>
          </Grid>
        </Grid>
        <Grid>
          <Box>
            <TableContainer component={StyledPaper}>
              <Table sx={{ minWidth: 650,  border: '2px solid lightgray' }} aria-label="simple table">
                <PricingTableHeader />
                <TableBody>
                  {paginatedData.map((row) => (
                    <PricingTableRow row={row} termFilter={termFilter}/>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
        <PricingTablePagination 
          count={filteredData.length}
          rowsPerPage={rowsPerPage} 
          page={page} 
          onPageChange={handleChangePage} 
          onRowsPerPageChange={handleChangeRowsPerPage} 
        />
      </Grid>
    </React.Fragment>
  );
}
